import React from 'react';
import { Navigate } from 'react-router-dom';
import { get_token } from './util.js';

function RequireAuth({ children }) {
  if (!get_token()) {
    return <Navigate to="/signin" />;
  }

  return children;
}

export default RequireAuth; 